import {AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS} from "admin-on-rest";

const parseJWT = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/'-'/g, '+').replace(/'_'/g, '/');
  return JSON.parse(window.atob(base64));
}

const clearLocalStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('email');
  localStorage.removeItem('role');
  localStorage.removeItem('kiosk')
}

export default (type, params) => {
  // called when the user attempts to log in
  if (type === AUTH_LOGIN) {
    const {username, password} = params;

    const headers = new Headers({
      'Content-Type': "application/json",
      'Authorization': process.env.REACT_APP_AUTH_HEADER
    });

    const request = new Request(process.env.REACT_APP_API_URL + '/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email: username, password: password }),
      headers: headers
    });

    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ access_token, roles, kiosks }) => {
        const parsedToken = parseJWT(access_token);
        localStorage.setItem('token', access_token);
        localStorage.setItem('email', parsedToken.email);
        localStorage.setItem('role', roles[0]);
        if ( kiosks && kiosks.length > 0) {
          localStorage.setItem('kiosk', JSON.stringify(kiosks[0]));
        }
        return Promise.resolve();
      });
  }
  // called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    clearLocalStorage()
    return Promise.resolve();
  }
  // called when the API returns an error
  if (type === AUTH_ERROR) {
    const {status} = params;
    if (status === 401 || status === 403) {
      clearLocalStorage()
      return Promise.reject();
    }
    return Promise.resolve();
  }
  // called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    return localStorage.getItem('token')
      ? Promise.resolve()
      : Promise.reject();
  }
  if (type === AUTH_GET_PERMISSIONS) {
      const role = localStorage.getItem('role');
      return Promise.resolve(role);
    }
  return Promise.reject("Unknown method");
};



// WEBPACK FOOTER //
// ./src/authClient.js